/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

export const plural = (word: string, count: number) => {
  const regexp = new RegExp(/([^aeiouy]|qu)y$/i);
  const beginning = count !== 1 && regexp.test(word) ? word.slice(0, -1) : word;
  const ending = count === 1 ? '' : regexp.test(word) ? 'ies' : 's';
  return `${beginning}${ending}` as const;
};
